export const WIN_MESSAGES = [
  'You just caught this beauty!',
  'Another fish added to your collection',
  'You hooked a new one today!',
  'The pond never disappoints you',
  'Fresh catch straight from the waters',
  'One more fish added to your logbook',
  'You can’t believe you caught this!',
  'Your fishing skill leveled up!',
  'This one put up a fight for you',
  'You should be proud of this catch',
  'The biggest one for you so far!',
  'Another day, another fish for you',
  'This one deserves a spot in your memories',
  'You got lucky this time!',
  'A rare catch for your records!',
  'Straight out of the waters',
  'This one surprised you',
  'Fishing pays off for you',
  'Another lucky strike on your rod',
  'What a catch you landed!',
  'The lake rewarded you again',
  'This one belongs to you now',
  'Another fish, another story for you',
  'You pulled this one out just now',
  'You couldn’t let this one get away',
  'Your fishing goals achieved',
  'Caught and logged in your record!',
  'The hunt continues for you',
  'You landed another one',
  'This one was tricky for you',
  'Your patience paid off',
  'Straight into your net',
  'Catching never gets old for you',
  'Today’s lucky find is yours',
  'Hook, line, and sinker for you!',
  'The waters are kind to you today',
  'This one almost escaped your line',
  'A new trophy for your collection',
  'Fishing success is yours!',
  'A solid catch for your rod',
  'Your adventure continues',
  'Proof of your patience',
  'Another notch on your fishing rod',
  'This fish tells your story',
  'Worth your wait',
  'Straight from the depths to you',
  'Today’s highlight is your catch!',
  'Catch of the day is yours',
  'From water to your hands',
  'Another memory for your log',
]

export const LOST_MESSAGES = [
  'Your fish took a day off',
  'The fish ghosted you',
  'Your bait got ignored',
  'Your hook is now just decoration',
  'The fish swiped left on your bait',
  'Your patience caught only bubbles',
  'Your rod enjoyed the sun instead',
  'The fish formed a union against you',
  'Your bait became a free snack',
  'Your catch of the day: disappointment',
  'The fish are laughing underwater',
  'Your rod just practiced yoga today',
  'Your bait got friend-zoned',
  'The only thing you caught is fresh air',
  'Your line is fishing for compliments',
  'The fish staged a strike',
  'Your cast earned zero likes',
  'Your hook became fish furniture',
  'The fish RSVP’d "no" to your invite',
  'Your patience just got roasted',
]
